"use client";

import { useEffect, useState } from "react";

export default function Googlemap({ address }: { address: string }) {
    const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
    // The location of KL
    const position = { lat: 3.148, lng: 101.702 };
    const [height, setHeight] = useState<number>();
    // make the address into one line
    const addressArray = address.split("\n");
    address = addressArray.join(", ");

    // if read & in address, change it to &amp;
    if (address.includes("&")) {
        address = address.replace("&", "&amp;");
    }

    useEffect(() => {
        if (typeof window !== "undefined" && window.innerWidth > 768) {
            setHeight(700);
        } else {
            setHeight(300);
        }
    }, []);

    return (
        <div className="google-map-code">
            <iframe
                width="100%"
                height={height}
                style={{
                    border: 0,
                    pointerEvents: "none",
                }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${address}`}
            ></iframe>
        </div>
    );
}
